import React, { useState, useCallback, useEffect, useRef } from 'react'
import {
  NavActionCon,
  NavbarCon,
  SiteNavBrand,
  DesktopNav,
  DesktopNavItem,
  SiteNavLink,
  RightActions,
  MobileActions,
  ProfileIconWrapper,
  MobileNavOverlay,
} from './styles'
import { SubMenu } from './SubMenu'
import { NavToggle } from '../NavToggle/NavToggle'
import { NavItems } from './NavItems'
import {
  MAIN_PLL_HOME,
  PLL_LINKS,
  NAV_LINKS,
  TEAM_MENU,
  MORE_MENU,
  PLL_SITE_LOGO,
} from '../../../Config/League/league.config'
import { Img } from '../../Images/Img'
import { AccountCircleOutlined } from '../../LazyComponents/lazyIcons'
import { Lk } from '../../../Utils/routing'

export const SiteNavbar: React.FC = () => {
  const [open, setOpen] = useState(false)
  const toggleRef = useRef<HTMLButtonElement>(null)

  const handleOverlayClick = useCallback((): void => {
    setOpen(false)
  }, [])

  useEffect(() => {
    if (!open) return undefined

    const handleEscape = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        setOpen(false)
        toggleRef.current?.focus()
      }
    }
    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [open])

  return (
    <>
      <NavbarCon aria-label="Main navigation">
        <SiteNavBrand>
          <Lk link={MAIN_PLL_HOME} alt="PLL home">
            <Img src={PLL_SITE_LOGO} alt="PLL Navbar logo" />
          </Lk>
        </SiteNavBrand>

        <DesktopNav>
          <SubMenu menuText="Teams" options={TEAM_MENU} />
          {NAV_LINKS.map((item) => (
            <DesktopNavItem key={item.linkText}>
              <SiteNavLink>
                <Lk link={item.link} alt={item.linkText}>{item.linkText}</Lk>
              </SiteNavLink>
            </DesktopNavItem>
          ))}
          <SubMenu menuText="More" options={MORE_MENU} />
        </DesktopNav>

        <RightActions>
          <NavActionCon href={PLL_LINKS.schedule}>
            Tickets
          </NavActionCon>
          <ProfileIconWrapper>
            <Lk link={PLL_LINKS.login} alt="Profile">
              <AccountCircleOutlined />
            </Lk>
          </ProfileIconWrapper>
        </RightActions>

        <MobileActions>
          <NavActionCon href={PLL_LINKS.schedule}>
            Tickets
          </NavActionCon>
          <NavToggle ref={toggleRef} open={open} setOpen={setOpen} />
        </MobileActions>
      </NavbarCon>

      <MobileNavOverlay open={open} onClick={handleOverlayClick} aria-hidden="true" />
      <NavItems open={open} setOpen={setOpen} />
    </>
  )
}
